import { inject, injectable } from 'inversify';
import {
  army_list_unit_model_rule_troop,
  army_list_unit_model_rule_troop_dto,
} from '@Api';
import { ArmyListUnitModelRuleTroop, TypeRule } from '@Models';
import { TYPES } from '@Types';
import { TypeLvlMapper } from '../ninthAge/TypeLvlMapper';

@injectable()
export class ArmyListUnitModelRuleTroopMapper {
  @inject(TYPES.Mapper.TypeLvlMapper) private _typeLvlMapper!: TypeLvlMapper;

  public map(
    item: army_list_unit_model_rule_troop,
  ): ArmyListUnitModelRuleTroop {
    return {
      id: item.id,
      modelRuleId: item.model_rule_id,
      unitId: item.unit_id,
      unitOptionId: item.unit_option_id,
      unitOptionChangeModelRuleId: item.unit_option_change_model_rule_id,
      troopId: item.troop_id,
      name: item.name,
      description: item.description ?? '',
      info: item.info,
      typeLvl: this._typeLvlMapper.map(item.type_lvl),
      modelRuleUnitTroopId: item.model_rule_unit_troop_id,
      isEnabled: item.is_enabled,
      isVisible: item.is_visible,
      typeRule: this.mapTypeRule(item.type_rule),
      isSelected: false,
    } satisfies ArmyListUnitModelRuleTroop as ArmyListUnitModelRuleTroop;
  }

  public mapTypeRule(
    item: army_list_unit_model_rule_troop.type_rule,
  ): TypeRule {
    switch (item) {
      case army_list_unit_model_rule_troop.type_rule.EQUIPMENT:
        return TypeRule.Equipment;
    }
    return TypeRule.SpecialRule;
  }

  mapDto(
    item: ArmyListUnitModelRuleTroop,
  ): army_list_unit_model_rule_troop_dto {
    return {
      id: item.id != '' ? item.id : null,
      model_rule_id: item.modelRuleId,
      unit_id: item.unitId,
      unit_option_id: item.unitOptionId,
      unit_option_change_model_rule_id: item.unitOptionChangeModelRuleId,
      troop_id: item.troopId,
      type_lvl: this._typeLvlMapper.mapDto(item.typeLvl),
      model_rule_unit_troop_id: item.modelRuleUnitTroopId,
      is_enabled: item.isEnabled,
      is_visible: item.isVisible,
    };
  }
}
